import React, { useEffect } from 'react';
import styled from 'styled-components';
import { fadeIn } from './styles/animations';
import { observer } from 'mobx-react-lite';
import { useStore } from './store';
import { Layout } from './components/styled';
import { Main } from './components/main';
import { WorkshopSelect } from './components/workshop-select';
import ThemeProvider from './styles/skins';
import ThemeSwitcher from './components/theme-switcher';
import {
  BackgroundSvgOne,
  // BackgroundSvgs,
  BackgroundSvgThree,
  BackgroundSvgTwo,
} from "./components/svgs/backgrounds/sounding-the-downs";
import { BackgroundOne, BackgroundTwo, BackgroundThree } from './components/styled';
import './styles/global';

const Snackbar = styled.div`
  position: fixed;
  top: 25rem;
  left: 50%;
  transform: translate(-50%, 0);
  background: grey;
  color: white;
  font-size: 1.6rem;
  padding: 1rem;
  transition: all 200ms;
  pointer-events: none;
  width: 50rem;
  max-width: 94vw;
  z-index: 9999;
  animation: ${fadeIn} 200ms;
`;

const AppContent = observer(() => {
  const store = useStore();

  // useEffect(() => {
  //   const selectedSkin = 'default'; // Replace with logic to select the appropriate skin
  //   APIClient.get_skin(selectedSkin).then(skin => {
  //     if (skin) {
  //       document.documentElement.style.setProperty('--background-color', skin.background);
  //       document.documentElement.style.setProperty('--button-image', `url(${skin.button})`);
  //       document.documentElement.style.setProperty('--primary-color', skin.color_palette.primary);
  //       document.documentElement.style.setProperty('--secondary-color', skin.color_palette.secondary);
  //       document.documentElement.style.setProperty('--accent-color', skin.color_palette.accent);
  //     }
  //   }).catch(error => {
  //     console.error('Error fetching skin:', error);
  //   });
  // }, []);

  let port = '';
  if (store.settings.server.port !== 80 || store.settings.server.port !== 443) {
    port = store.settings.server.port;
  }
  const portToUse = port !== "" ? `:${port}` : '';
  const serverAddress = store.settings.server.url;

  const baseUrl = `${store.settings.server.protocol}${serverAddress}${portToUse}`;

    useEffect(() => {
    fetch(
      baseUrl + "/get_csrf/",
      {
        credentials: "include", // important for cookies to be sent and received
      }
    )
      .then((response) => {
        // Handle response and possibly update state/context
        console.log("CSRF token fetched and cookie set by the server");

        const csrftoken = store.readCookie("csrftoken");

        fetch(
          baseUrl +
            "/api/create_device/",
          {
            method: "POST",
            headers: { "X-CSRFToken": csrftoken },
            credentials: "include", // This will ensure cookies are sent and received
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("Device UUID:", data.device_uuid);
            store.deviceIdUpdate = data.device_uuid;
            // You can store this UUID in your state or context if needed
          })
          .catch((error) => console.error("Error:", error));
      })
      .catch((error) => console.error("Error fetching CSRF token:", error));
  }, [store, baseUrl]); // The empty array makes this effect run only on mount

  // const handleButtonPress = (deviceNumber) => {
  //   const timestamp = new Date().toISOString();
  //   store.trackButtonPress(deviceNumber, timestamp);
  // };
  //
  useEffect(() => {
      const tryJoinFromUrl = async () => {
        const params = new URLSearchParams(window.location.search);
        const roomFromUrl = params.get('room');
        console.log('roomFromUrl', roomFromUrl);

        if (roomFromUrl && !store.selectedRoom) {
          const isValid = await store.checkWorkshopCode(roomFromUrl);
          if (!isValid) {
            console.warn(`Invalid room code: ${roomFromUrl}`);
            store.showSnackBar("Can't find a workshop with that URL code.");
          }
        }
      };

      tryJoinFromUrl();
    }, [store]);

  return (
    <Layout>
      {store.workshopCodeOk ? <Main /> : <WorkshopSelect />}

      {store.snackbars.map(({ id, content }, i) => (
        <Snackbar key={id} style={{ transform: `translate(-50%, ${0 - 5 * i}rem)` }}>
          {content}
        </Snackbar>
      ))}

      <BackgroundOne>
        <BackgroundSvgOne />
      </BackgroundOne>

      <BackgroundTwo>
        <BackgroundSvgTwo />
      </BackgroundTwo>

      <BackgroundThree>
        <BackgroundSvgThree />
      </BackgroundThree>

      {/* comment this (or put behing a DEV mode toggle) to hide */}
      {store.isStaff && <ThemeSwitcher />}
    </Layout>
  );
});

export const App = () => (
  <ThemeProvider initialSkin="blank">
    <AppContent />
  </ThemeProvider>
);
